import { UrlUtils } from '@atlassian/mpac-utils';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';

export const mpacHosting = (hosting) => {
  switch (hosting) {
    case 'cloud':
      return 'cloud';
    case 'server':
      return 'server';
    case 'dataCenter':
      return 'datacenter';
    default: {
      console.error('Invalid hosting provided : ' + hosting);
      return '';
    }
  }
};

export function encodeAppName(name) {
  return name
    .replace(/['`´‘’]/g, '')
    .replace(/<\/?.*?>/g, ' ')
    .split(/\W/)
    .filter((s) => s && s.trim() !== '')
    .map((s) => s.toLowerCase().trim())
    .join('-');
}

export function resolveHitHref({ appId, appName, hosting, generalLinks }) {
  return UrlUtils.resolveUrlFromTemplateAndParameters({
    template: generalLinks.addonListingWithHosting.href,
    parameters: {
      pluginId: appId,
      appName: encodeAppName(appName),
      hosting: mpacHosting(hosting),
      tab: 'overview',
    },
  });
}

export function resolveHitImageHref({ hit, generalLinks }) {
  const hitImage = hit.getIn(['logo', 'highRes']) || hit.getIn(['logo', 'image']);

  if (hitImage) {
    return decodeURIComponent(
      UrlUtils.resolveUrlFromTemplateAndParameters({
        template: generalLinks.files.href,
        parameters: { fileName: hitImage },
      })
    );
  }
}

export function navigateToAddon({ appId, appName, hosting, generalLinks }, history) {
  const hitLocation = resolveHitHref({ appId, appName, hosting, generalLinks });
  history.push(hitLocation);
}

export function resolveHostingFromHit({
  hit,
  filters,
  preferredHosting,
}: {
  hit: typeof ImmutablePropTypes.record;
  filters?: typeof ImmutablePropTypes.map;
  preferredHosting?: string;
}) {
  if (preferredHosting && hit.get('deployments').includes(preferredHosting)) {
    return preferredHosting;
  } else if (!hit.get('deployments').includes('cloud')) {
    return hit.get('documentType');
  } else if (!filters) {
    return 'cloud';
  } else {
    const moreFilters = filters.get('moreFilters');
    // We should not default to cloud if free is selected as an app may have 1 version free / another paid, same with beta version.
    const noFreeOrBetaVersionFilter = !(
      moreFilters &&
      (moreFilters.includes('free') || moreFilters.includes('betaVersion'))
    );
    const noHostingFilter = !filters.get('hosting');

    return noHostingFilter && noFreeOrBetaVersionFilter ? 'cloud' : hit.get('documentType');
  }
}
